export default __webpack_public_path__ + "static/media/Krishna_Satti_Resume.03e277f0.pdf";